// extracted by mini-css-extract-plugin
export default {"container":"K1-z"};